import React from 'react';
import WayFadeUp from '../components/transitions/WayFadeUp';

const SingleIntroText = ({ id, quote, text, color }) => {
  const headerStyles = {
    color: `${color}`,
  };
  return (
    <WayFadeUp>
      <div id={id} className='mt4 mb4 mt6-l mb6-l pl4 pr4 tl tc-l'>
        <div
          className='f2 f1-l grey measure-narrow center lh-copy tiempos'
          style={headerStyles}
        >
          {quote.text}
        </div>
        <div
          className='measure-widest center tiempos f3 tl grey mt5-l mw7 tc-l'
          dangerouslySetInnerHTML={{ __html: text.html }}
        />
      </div>
    </WayFadeUp>
  );
};

export default SingleIntroText;
